import { ListItem, UnorderedList } from '@chakra-ui/react';

import asBentoPage from 'common/bento/hoc/asBentoPage';
import Button from 'components/_core/Button';
import SunshineCard from 'components/_core/SunshineCard';
import SquircleIcon from 'components/_core/SunshineSquircleIcon';
import Text from 'components/_core/Text';
import OBNavigation from 'features/Onboarding/components/OBNavigation/OBNavigation';
import { ApplicantType, ApplicationType } from 'features/Onboarding/types';

import Header from '../../../../components/Header';
import CapitalDepositHeader from '../../components/CapitalDepositHeader';
import locales from './locales';

const MORE_INFO_LINK =
  'https://help.shine.fr/fr/articles/4305211-qu-est-ce-qu-un-beneficiaire-effectif';

interface IntroProps {
  onNext: () => void;
  applicationType: ApplicationType.Standard | ApplicationType.CapitalDeposit;
  applicantType: ApplicantType.AccountHolder | ApplicantType.Mandatee;
}

const BeneficiariesSummary = asBentoPage<IntroProps>(
  ({ applicantType, applicationType, Layout, onNext, onPrev }) => {
    const isCapitalDeposit = applicationType === ApplicationType.CapitalDeposit;

    return (
      <Layout nav={<OBNavigation onPrev={onPrev} />}>
        {isCapitalDeposit ? (
          <CapitalDepositHeader />
        ) : (
          <>
            <Header
              description={locales.intro}
              linkText={locales.moreInfoLink}
              linkUrl={MORE_INFO_LINK}
              title={locales.title}
            />
            <Text marginBottom="space-16">{locales.cardIntroduction}</Text>
          </>
        )}

        <SunshineCard.Group isBoxed={false}>
          <SunshineCard
            alignItems="center"
            title={locales.step1Title[applicantType][applicationType]}
          >
            <SunshineCard.Slot name="aside">
              <SquircleIcon name="team" />
            </SunshineCard.Slot>

            <SunshineCard.Content>
              <SunshineCard.Text>{locales.step1Description}</SunshineCard.Text>
            </SunshineCard.Content>
          </SunshineCard>

          <SunshineCard alignItems="center" title={locales.step2Title}>
            <SunshineCard.Slot name="aside">
              <SquircleIcon name="mail" />
            </SunshineCard.Slot>

            <SunshineCard.Content>
              <SunshineCard.Text>
                {locales.step2Description[applicantType]}
              </SunshineCard.Text>
            </SunshineCard.Content>
          </SunshineCard>

          <SunshineCard alignItems="center" title={locales.step3Title}>
            <SunshineCard.Slot name="aside">
              <SquircleIcon name="edit-file" />
            </SunshineCard.Slot>

            <SunshineCard.Content>
              <UnorderedList>
                {locales.step3Substeps.map((substep) => (
                  <ListItem key={substep}>
                    <SunshineCard.Text>{substep}</SunshineCard.Text>
                  </ListItem>
                ))}
              </UnorderedList>
            </SunshineCard.Content>
          </SunshineCard>
        </SunshineCard.Group>

        <Button isExpanded marginTop="space-24" onClick={onNext}>
          {locales.cta}
        </Button>
      </Layout>
    );
  },
);

export default BeneficiariesSummary;
